// extracted by mini-css-extract-plugin
export var badges = "platform_section-module--badges--QAM9H";
export var benefits = "platform_section-module--benefits--dc4i3";
export var benefits_description = "platform_section-module--benefits_description--rPAsN";
export var benefits_part = "platform_section-module--benefits_part--XyDRn";
export var button_container = "platform_section-module--button_container--OiUi4";
export var laptop_heading = "platform_section-module--laptop_heading--2RCoh";
export var mobile_heading = "platform_section-module--mobile_heading--mZ8Gp";
export var mocap_img = "platform_section-module--mocap_img--4jCMN";
export var platform_description = "platform_section-module--platform_description--zZ0kF";
export var platform_section = "platform_section-module--platform_section--cRTRs";